import { render, staticRenderFns } from "./DashboardSectionHeader.vue?vue&type=template&id=29371b8c&scoped=true&"
import script from "./DashboardSectionHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardSectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSectionHeader.vue?vue&type=style&index=0&id=29371b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29371b8c",
  null
  
)

export default component.exports